import { useEffect } from 'react';

import { loadScript } from '../script';

interface UseFacebookProps {
  appId?: string;
}

/**
 * Load facebook script, (if already did, then do nothing)
 * to replace `FacebookScript`
 */
export const useFacebook = (props?: UseFacebookProps) => {
  const appId = props?.appId || process.env.NEXT_PUBLIC_FB_APP_ID;
  useEffect(() => {
    if (!window.fbAsyncInit && appId) {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId,
          cookie: true,
          xfbml: true,
          version: 'v2.8',
        });
      };

      loadScript('https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js', 'facebook-jssdk');
    }
    // Only run once after loaded
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
